const MapType = Object.freeze({
  DEFAULT: "DEFAULT",
  ROAD: "ROAD",
  SATELLITE: "SATELLITE",
  TERRAIN: "TERRAIN",
  HYBRID: "HYBRID"
});
export default MapType;